(function ($) {
    $(".mobile-navbar li.menu-item-has-children > a").one("click", function () {
        var target = $(this);
        var value = target.attr("href");
        var element = target.parent("li");
    
        target.removeAttr("href");
    
        element
          .children("ul")
          .first("li")
          .prepend('<li><a href="' + value + '"><span class="title-container">Overview</span></a></li>');
    });
})(jQuery);